import { useSite } from "@/context/SiteContext";

/** Explains the follow-up process beside the upload offer. Response-time wording is admin-editable. */
export default function FollowUpPanel() {
  const { config, content, openLead } = useSite();
  const rows = [
    ["What you receive", "A personalized review built from your bill and calculator inputs — usage summary, energy vs demand charges, preliminary sizing, potential benefits and a payback summary, with assumptions disclosed."],
    ["Who reviews it", "The Solar Black Belt project team. Your files, calculator inputs and property details stay together in one private project record with a reference number."],
    ["How results are delivered", "We review your submission manually and follow up by phone or email. There is no automated bill analysis — anything unreadable or missing in your bills is flagged for you, not guessed."],
    ["What may be needed next", "Up to 12 monthly bills, a utility interval-data export for demand analysis, and your tax adviser's confirmation for any incentive scenario."],
  ];
  return (
    <div className="followup-panel" data-testid="followup-panel">
      <span className="eyebrow">WHAT HAPPENS NEXT</span>
      <h3>After you upload, here's the process.</h3>
      <dl>
        {rows.map(([t, d]) => (
          <div key={t}>
            <dt>{t}</dt>
            <dd>{d}</dd>
          </div>
        ))}
        <div>
          <dt>Response time</dt>
          <dd data-testid="response-time-note">
            {content.responseTimeNote || content.followUpNote || "We'll confirm the next steps and review timeline after receiving your bill."}
          </dd>
        </div>
      </dl>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 18 }}>
        <button
          className="btn light"
          data-testid="callback-request"
          onClick={() => openLead("contact", "Callback request")}
        >
          Request a callback <span>↗</span>
        </button>
        <a className="btn light" href={config.phoneHref}>
          Call {config.phone}
        </a>
      </div>
    </div>
  );
}
